export default "__VITE_ASSET__757198d8__"